// src/pages/SignInPage.tsx
import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';

export default function SignInPage() {
  const { loginWithRedirect, isAuthenticated, isLoading, error } = useAuth0();

  if (isLoading) {
    return <div style={{ textAlign: 'center', marginTop: '50px' }}>Loading...</div>;
  }

  if (isAuthenticated) {
    // Optionally, redirect if already authenticated
    // You might want to use react-router-dom's Navigate component or history.push here
    // For now, just showing a message.
    return (
      <div style={{ textAlign: 'center', marginTop: '50px' }}>
        <h1>Sign In</h1>
        <p>You are already logged in.</p>
        {/* You could add a link to the user's profile or dashboard here */}
      </div>
    );
  }

  return (
    <div style={{ maxWidth: '400px', margin: '40px auto', padding: '20px', border: '1px solid #ccc', borderRadius: '8px', textAlign: 'center' }}>
      <h1>Sign In</h1>
      {error && (
        <p style={{ color: 'red' }}>
          Authentication Error: {error.message}
        </p>
      )}
      <p>Please log in to continue.</p>
      <button 
        onClick={() => loginWithRedirect()}
        style={{
          padding: '10px 20px',
          fontSize: '16px',
          backgroundColor: '#007bff',
          color: 'white',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer'
        }}
      >
        Log In with Auth0
      </button>
    </div>
  );
}